/**
 * Possible states of calendar cells.
 * These are for the big-picture status of a cell
 */
export const CALENDAR_CELL_STATES = {
  PITCH: {
    AVAILABLE: 'PITCH_AVAILABLE',
    SELECTED: 'PITCH_SELECTED',
    SELECTED_END: 'PITCH_SELECTED_END',
    FULL: 'PITCH_FULL',
    SELECTED_FULL: 'PITCH_SELECTED_FULL',
    CLOSED: 'PITCH_CLOSED',
    DISABLED: 'PITCH_DISABLED',
    LOADING: 'PITCH_LOADING',
    CONTACT_US: 'PITCH_CONTACT',
    SELECTED_CONTACT_US: 'PITCH_SELECTED_CONTACT',
    PLAIN: 'PITCH_PLAIN',
    BOOKED_UNSELECTED: 'PITCH_BOOKED_UNSELECTED',
    BOOKED_UNSELECTED_LAST: 'PITCH_BOOKED_UNSELECTED_LAST',
  },
  NEUTRAL: {
    AVAILABLE: 'NEUTRAL_AVAILABLE',
    SELECTED: 'NEUTRAL_SELECTED',
    SELECTED_END: 'NEUTRAL_SELECTED_END',
    FULL: 'NEUTRAL_FULL',
    SELECTED_FULL: 'NEUTRAL_SELECTED_FULL',
    CLOSED: 'NEUTRAL_CLOSED',
    DISABLED: 'NEUTRAL_DISABLED',
    LOADING: 'NEUTRAL_LOADING',
    CONTACT_US: 'NEUTRAL_CONTACT',
    SELECTED_CONTACT_US: 'NEUTRAL_SELECTED_CONTACT',
    PLAIN: 'PITCH_PLAIN',
    BOOKED_UNSELECTED: 'NEUTRAL_BOOKED_UNSELECTED',
    BOOKED_UNSELECTED_LAST: 'NEUTRAL_BOOKED_UNSELECTED_LAST',
  },
};

/**
 * Modifiers for any information about a cell that
 * modifies the cell state, e.g. 'LOW' adds an
 * indicator to existing cell styling, 'LAST_DAY'
 * cuts the background in half, etc.
 */
export const CALENDAR_CELL_MODIFIERS = {
  LOW: 'LOW',
  LAST_DAY: 'LAST_DAY',
  BOOKED: 'BOOKED',
};

export const SELECTED_DATES_STAY_STATUS = {
  CONTINUOUS_PITCH_AVAILABLE: 1,
  NO_PITCHES_AVAILABLE: 2,
  MUST_BOOK_ACROSS_PITCHES: 3,
};
